/* eslint-disable no-undef */
import { createAction } from "@reduxjs/toolkit";
import { constructUrl } from "@utils/helpers";

const BASE_URL = "api/report/";
const InitActionCreator = ({ baseUrl, method }) => {
	return ({ type, endPoint, data, responseType, params, meta, headers }) => ({
		type,
		request: {
			url: baseUrl + endPoint,
			method,
			data,
			responseType,
		},
		headers,
		meta,
		params,
	});
};
const createGetAction = InitActionCreator({ baseUrl: BASE_URL, method: "GET" });

export const getJourneyTrendData = ({ isExportMode }) =>
	createGetAction({
		type: "GET_JOURNEY_TREND_DATA",
		endPoint: constructUrl("getDashboardData", {
			dashboardCode: "journeyTrends",
		}),
		params: { isExportMode },
	});

export const applyFilterJourneyTrend = createAction("APPLY_FILTER_JOURNEY_TRENDS");
